import React from 'react';
import { CancelButton } from './SaveSelectionPresetsModal';

const LoadPreset = ({ onClick }: { onClick: Function }) => {
    return (
        <div role="button" className="w-36 pt-2 absolute bottom-16 left-[50%] translate-x-[-50%]">
            <CancelButton className="w-full" onClick={() => onClick()}>
                Load Preset
            </CancelButton>
        </div>
    );
};

export default LoadPreset;
